import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { data } from '../../composables/useData';
 import { method } from '../../composables/useMethod';
 import { BarChart,LineChart } from 'vue-chart-3';
 import { Chart, registerables } from 'chart.js';
 import { computed,ref,watch,onMounted  } from 'vue';
 import dayjs from 'dayjs';
 
export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceCounts',
  setup(__props) {

 Chart.register(...registerables);
 const linechart = ref(null);
 onMounted(() => {
 
   if (linechart.value) {
     const chartInstance = linechart.value.chartInstance;
     console.log('Chart Data:', chartInstance.data);
   }
 });
 
 const selected = ref([]);
 const headers:any =ref( [
       {
         title: '日付',
         align: 'start',
         sortable: true,
         key: 'date',
       },
       { title: 'デスクトップ', align:'end',key:'activeUsers',sortable: true, },
       { title: 'モバイル', align:'end',key:'screenPageViews',sortable: true, },
       { title: 'タブレット', align:'end',key:'screenPageViews',sortable: true, },
     ]);
 const items = ref( method.report.sum());
 
 function updateItems(){
   items.value = method.report.sum();
 }
 watch(() => data.loginUser.activeReport, () => {
   updateItems();
 });
 
 const reportData = computed(() => {
  if (linechart.value) {
    const chartInstance = linechart.value.chartInstance;
    chartInstance.data.datasets = [];
  }

  console.log('selected.value', method.report.graphData('deviceData'));

  const chartData = method.report.graphData('deviceData').filter((item) => {
    return selected.value.find((reportData) => reportData.docId === item.docId);
  });

  console.log('chartData', chartData);

  if (!chartData[0]) {
    console.log('false');
    return {
      labels: [],
      datasets: [],
    };
  } else {
    console.log('true', data.viewItemModel);

    const datasets = chartData.map((item) => {
      console.log('item', item);

      const selectedItem = item.datasets.data.map((dataItem) => {
        console.log('datasets filter dataItem', dataItem);
        return dataItem[data.viewItemModel as string];
      });

      console.log('selectedItem', selectedItem);

      return {
        label: item.datasets.label,
        data: selectedItem,
        backgroundColor: item.datasets.backgroundColor,
        fill: item.datasets.fill,
      };
    });

    // labelsを最初のitemから取り出す
    const labels = chartData[0].labels;
    console.log('datasets', datasets);
    return {
      labels: data.reportPage.graph.dateLabels,
      datasets: datasets,
    };
  }
});
 
return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    align: "center",
    style: {"height":"750px"},
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "5",
        "align-self": "center",
        class: "mt-sm-5,mt-xs-5,ma-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_data_table, {
            headers: headers.value,
            items: items.value,
            "items-per-page": "12",
            "hide-default-footer": "",
            "show-select": "",
            modelValue: selected.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
            "item-value": "docId",
            "return-object": ""
          }, null, 8, ["headers", "items", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "5",
        "align-self": "center",
        class: "ma-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(LineChart), {
            chartData: reportData.value,
            options: _unref(data).reportPage.graph.options,
            ref_key: "linechart",
            ref: linechart
          }, null, 8, ["chartData", "options"]),
          _createVNode(_component_v_select, {
            label: "表示項目",
            items: _unref(data).viewItem,
            "item-title": "title",
            "item-value": "value",
            modelValue: _unref(data).viewItemModel,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).viewItemModel) = $event))
          }, null, 8, ["items", "modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})